/* eslint-disable consistent-return */
import {
  PaperEmbeddedWalletSdk,
  RecoveryShareManagement,
} from '@paperxyz/embedded-wallet-service-sdk';
import {AbstractConnector} from '@web3-react/abstract-connector';
import {ConnectorUpdate} from '@web3-react/types';
import {Chain, ConstructorOptions} from './types';
import {AUTHENTICATION_MESSAGE_TO_SIGN, PAPERCHAINS} from './const';
import {setSignatureCookies, getAuthenticatedWalletState} from './utils';

export class PaperConnector extends AbstractConnector {
  public paper: PaperEmbeddedWalletSdk | undefined;

  private readonly chain: Chain;

  private readonly options: ConstructorOptions;

  private readonly clientId: string;

  private isSwitched = false;

  constructor(clientId: string, options: ConstructorOptions) {
    super();
    this.options = {
      chain: options.chain,
    };
    this.clientId = clientId;
    this.paper = new PaperEmbeddedWalletSdk({
      clientId,
      chain: options.chain,
      //   advancedOptions: {
      //     recoveryShareManagement: RecoveryShareManagement.,
      //   },
    });
    this.chain = options.chain;
    this.isSwitched = options.isSwitched || false;
  }

  public async getProvider(): Promise<PaperEmbeddedWalletSdk | undefined> {
    return this.paper;
  }

  public async getChainId(): Promise<string | number> {
    return PAPERCHAINS[this.chain];
  }

  public async getAccount(account?: string | null): Promise<string | null> {
    if (!account) return null;
    return account;
  }

  public async activate(): Promise<ConnectorUpdate<string | number>> {
    if (!this.paper) {
      const {PaperEmbeddedWalletSdk} = await import(
        '@paperxyz/embedded-wallet-service-sdk'
      );
      this.paper = new PaperEmbeddedWalletSdk({
        clientId: this.clientId,
        chain: this.options.chain,
        //   advancedOptions: {
        //     recoveryShareManagement: RecoveryShareManagement.,
        //   },
      });
    }
    const {chainId, address, provider} = getAuthenticatedWalletState() || {
      chainId: undefined,
      address: undefined,
      provider: undefined,
      userId: undefined,
    };
    if (chainId && address && provider === 'paper' && !this.isSwitched) {
      return {
        chainId,
        account: address,
        provider: await this.getProvider(),
      };
    }
    const resp = await this.paper?.auth.loginWithPaperModal();
    const signer = await resp.user.wallet.getEthersJsSigner();
    const nonce = `${AUTHENTICATION_MESSAGE_TO_SIGN} @ ${new Date().toLocaleString()}`;

    const signature = await signer.signMessage(nonce);

    setSignatureCookies(signature);

    return {
      account: await this.getAccount(resp.user.walletAddress),
      chainId: await this.getChainId(),
      provider: await this.getProvider(),
    };
  }

  public async deactivate(): Promise<void> {
    await this.paper?.auth.logout();
  }
}
